var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkStatus, getAvailableSources, getAvailableSourcesForHistoricalData, executeQuery, getSchema, aiSearch, applyCopilot, getCustomTransformation, askQuestion, getSampleQuestions, resetConfig, exportCsv, getQueryDataSource } from '@query-engine-service';
import { prepareSources, prepareQuery, generateInitialQuery } from '@utils';
export const useQueryEngineService = (uxpContext) => {
    const context = {
        uxpContext
    };
    return {
        checkStatus: () => checkStatus(context),
        getCatalog: () => getAvailableSources(context),
        getCatalogForHistory: () => getAvailableSourcesForHistoricalData(context),
        executeQuery: (query, params) => executeQuery(context, query, params),
        getSchema: query => getSchema(context, query),
        aiSearch: (request) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield aiSearch(context, request);
            if (result === null || result === void 0 ? void 0 : result.pipeline) {
                const prepared = yield prepareQuery(context, result.pipeline);
                result.pipeline = generateInitialQuery(prepared);
            }
            return result;
        }),
        aiCopilot: (query, description) => applyCopilot(context, query, description),
        aiCustomTransform: description => getCustomTransformation(context, description),
        aiQuestion: question => askQuestion(context, question),
        aiSampleQuestions: () => getSampleQuestions(context),
        getQueryDataSourceById: (queryId) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield getQueryDataSource(context, queryId);
            if (!(res === null || res === void 0 ? void 0 : res.source))
                return null;
            const { sources } = prepareSources([res.source], []);
            return sources[0];
        }),
        refreshDatasources: () => resetConfig(context),
        exportCsv: query => exportCsv(context, query)
    };
};
